<div class="flex flex-col h-full">
  <!-- Content Area -->
  <div class="flex-1 flex flex-col items-center justify-center">
    <!-- Icon and Message -->
    <div class="flex flex-col items-center text-center mb-8">
      <!-- Lock Shield Icon -->
      <div class="mb-6">
        <svg
          width="73"
          height="96"
          viewBox="0 0 73 96"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M41.8301 92.5406C42.4483 92.2675 43.0431 91.953 43.6223 91.5972L41.8301 92.5406Z"
            stroke="#111827" />
          <path
            d="M53.3964 41.7683C52.6138 39.9641 51.5886 38.3834 50.3364 37.0262L49.632 36.2814L42.166 28.32L30.7242 16.1296C29.9651 15.3351 29.1981 14.6979 28.439 14.2345C27.672 13.771 26.9128 13.4731 26.1459 13.3324L17.9441 12.0579L6.5416 10.2869C5.70421 10.171 4.97633 10.2869 4.34242 10.6179C4.02938 10.7834 3.73983 11.0069 3.47374 11.2883C2.6833 12.1324 2.29199 13.3738 2.29199 15.0289V33.7655C2.29199 43.0262 4.46772 52.9986 8.82682 63.691C13.186 74.3834 19.0399 83.462 26.3964 90.9269C26.7251 91.2579 27.046 91.5558 27.3746 91.8207C27.7033 92.0855 28.0555 92.3338 28.439 92.5655C28.8225 92.7972 29.1746 92.9793 29.5033 93.12C29.8242 93.2524 30.1529 93.3517 30.4816 93.4179C34.7468 94.2951 38.5112 94.0138 41.7668 92.5738L41.8294 92.5407L43.6216 91.5972C45.2416 90.5958 46.7207 89.28 48.0512 87.6331C48.5755 86.9793 49.0763 86.3007 49.538 85.5972C52.9033 80.4662 54.586 73.8289 54.586 65.6938V46.9572C54.586 45.302 54.1868 43.5724 53.3964 41.7683ZM34.0894 52.8662C34.0894 52.8662 34.0503 52.9241 34.0346 52.9489C33.4086 53.8262 32.5477 54.2565 31.4599 54.2565L33.0094 65.611C33.1189 66.2731 33.0094 66.7448 32.6416 67.0262C32.2894 67.3076 31.8668 67.2993 31.3816 66.9931L29.4954 65.8427L25.4964 63.4014C25.0033 63.1034 24.5807 62.5986 24.2286 61.8869C23.8764 61.1751 23.7512 60.5545 23.8607 60.0248L24.5807 55.6469L25.4103 50.5655C24.3225 49.2414 23.4694 47.7517 22.8433 46.1214C22.2172 44.4827 21.9042 42.902 21.9042 41.3793C21.9042 39.1945 22.538 37.7214 23.8215 36.9517C25.0972 36.1738 26.639 36.3393 28.439 37.44C30.2312 38.5324 31.7729 40.2538 33.0564 42.5876C33.6512 43.6717 34.1051 44.7476 34.426 45.7986C34.7938 47.0069 34.9737 48.1986 34.9737 49.3572C34.9737 50.8303 34.6763 52.0055 34.0894 52.8662Z"
            fill="#E5E7EB"
            stroke="#111827" />
          <path
            d="M70.2385 38.6813V57.4179C70.2385 66.6786 68.0551 73.9862 63.7038 79.3572C61.9898 81.4675 60.0411 83.0482 57.8576 84.091L57.8106 84.1158L43.6219 91.5972C45.2419 90.5958 46.7211 89.28 48.0516 87.6331C48.5759 86.9793 49.0767 86.3006 49.5385 85.5972C52.9037 80.4662 54.5863 73.8289 54.5863 65.6937V46.9572C54.5863 45.302 54.1872 43.5724 53.3967 41.7682C52.6141 39.9641 51.5889 38.3834 50.3367 37.0262L49.6324 36.2813L42.1663 28.32L30.7245 16.1296C29.9654 15.3351 29.1985 14.6979 28.4393 14.2344C27.6724 13.771 26.9132 13.4731 26.1462 13.3324L17.9445 12.0579L6.54194 10.2868C5.70455 10.171 4.97669 10.2868 4.34277 10.6179L19.9324 2.37513L19.995 2.34204C20.6289 2.01101 21.3567 1.89513 22.1941 2.01099L41.7984 5.0565C42.5653 5.19719 43.3245 5.49515 44.0915 5.9586C44.8506 6.42204 45.6176 7.05927 46.3767 7.85375L65.9889 28.7503C67.2411 30.1075 68.2663 31.6882 69.0489 33.4924C69.8393 35.2965 70.2385 37.0262 70.2385 38.6813Z"
            fill="#F9FAFB"
            stroke="#111827" />
        </svg>
      </div>

      <!-- Title -->
      <h3 class="text-lg font-semibold text-gray-900 mb-2">
        Encryption not applied
      </h3>

      <!-- Description -->
      <p class="text-sm text-gray-500 max-w-xs">
        Lock your data for security or generate a new encryption key for secure
        access
      </p>
    </div>
  </div>

  <!-- Action Buttons (Bottom) -->
  @let isSubmittingValue = isSubmitting(); @let actionButtons = [{ id:
  'generate-new-key-btn', label: 'Generate New Key', variant:
  asActionButtonVariant('secondary'), disabled: isSubmittingValue }, { id:
  'lock-data-btn', label: isSubmittingValue ? 'Locking...' : 'Lock Data',
  variant: asActionButtonVariant('danger'), disabled: isSubmittingValue,
  loading: isSubmittingValue }];

  <app-action-buttons
    [buttons]="actionButtons"
    (buttonClick)="onActionButtonClick($event)" />
</div>
